module.exports = __webpack_public_path__ + "static/img/photo-forest-02.1fd8d98.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo-forest-02.jpg
// module id = sqnm
// module chunks = 1